import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LocalStorageUtil } from 'src/app/util/local-storage-util';

@Injectable({
  providedIn: 'root',
})
export class FinanceiroRoleGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    const account = LocalStorageUtil.getAccountInfo();

    if (account.financeiroRole) {
      return true;
    }
    this.router.navigate(['/patients']);
    return false;
  }
}
